import { put, call, takeEvery } from "redux-saga/effects";
import getCycles from "lib/requests/cycles";
import _ from "lodash";
import moment from "moment";
import { addCycleList } from "./slices";
import addCycleListAsyncAction from "./actions";

function* addCycleListAsync() {
  const cycles = yield call(getCycles);
  const sortedCycles = _.sortBy(cycles, (cycle) =>
    moment(cycle.initial_date, "YYYY-MM-DD")
  );

  yield put(addCycleList(sortedCycles));
}

export default function* watchAddCycleListAsync() {
  yield takeEvery(addCycleListAsyncAction, addCycleListAsync);
}
